/**
 * 사업자 정보 한 줄(접기 가능) — 전자상거래법 표시. 값은 lib/company-info(app_config 'company').
 * ⛔ 훅 없음 · 방문자 무관(같은 HTML). <details> 기본 접힘 — 펼침은 브라우저 기본 동작이라 JS 불필요.
 * 표시할 값이 하나도 없으면 null(아무것도 안 그림).
 */
import { companyInfoRows, type CompanyInfo } from '@/lib/company-info-shared';

export default function CompanyInfoLine({ info, className }: { info?: CompanyInfo | null; className?: string }) {
  const rows = companyInfoRows(info);
  if (!rows.length) return null;
  return (
    <details className={className ?? 'kd-ft__biz'} data-company-info="">
      <summary>사업자 정보</summary>
      <p>
        {rows.map((r, i) => (
          <span key={r.key} data-company-key={r.key}>
            {i > 0 ? ' · ' : ''}
            {r.label} {r.key === 'email' ? <a href={`mailto:${r.value}`}>{r.value}</a> : r.key === 'rep_tel' ? <a href={`tel:${r.value.replace(/-/g, '')}`}>{r.value}</a> : r.value}
          </span>
        ))}
      </p>
    </details>
  );
}
